/* tslint:disable:max-line-length */

import { Injectable, NgZone } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {  Observable } from 'rxjs';
import { InformacioSecundariaService } from '../../../controllers/InformacioSecundaria';
import * as __model from '../../../model';
import { APIConfigService } from '../../../apiconfig.service';

import * as __utils from '../../../yasag-utils';

import { YASAGPostFormService } from '../../yasag-post.service';


@Injectable()
export class InformacioSecundariaPartialUpdateFormService extends YASAGPostFormService<__model.InformacioSecundaria> {
  static xImiRoles = {"admin":"administrator can use this endpoint"};
  form = new FormGroup({
    data: new FormGroup({
      codi_informacio: new FormControl({value: undefined, disabled: false}, []),
      titol_ca: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512), Validators.minLength(1), Validators.required]),
      titol_es: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      titol_en: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      detall_ca: new FormControl({value: undefined, disabled: false}, []),
      detall_es: new FormControl({value: undefined, disabled: false}, []),
      detall_en: new FormControl({value: undefined, disabled: false}, []),
      enllaç_ca: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(200)]),
      enllaç_en: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(200)]),
      enllaç_es: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(200)]),
    }, [Validators.required]),
    fields: new FormControl({value: undefined, disabled: false}, []),
    expand: new FormControl({value: undefined, disabled: false}, []),
    codi_informacio: new FormControl({value: undefined, disabled: false}, [Validators.required]),
  });
  constructor(
    apiConfigService: APIConfigService,
    ngZone: NgZone,
    private service: InformacioSecundariaService,
  ) {
    super('InformacioSecundariaPartialUpdate', apiConfigService, ngZone);
    this.init();
  }

  submit(value: typeof this.form.value | false = false): Observable<__model.InformacioSecundaria> {
    const result = val => this.service.partialUpdate(val);
    return this._submit('__model.InformacioSecundaria', result, 'data', value, true );
  }
  listen(value: typeof this.form.value | false = false, submit: boolean = true): Observable<__model.InformacioSecundaria> {
    if (submit) {
      this.submit(value);
    }
    return this._listen(value, submit);
  }


  reset(value?: typeof this.form.value): void {
    this.form.reset();
    super.reset(value, true); 
  }
  patch(value: typeof this.form.value): void {
    this.form.patchValue(value);
  }
}
